import { render } from "./MenuCycle.vue?vue&type=template&id=9a90866a"
import script from "./MenuCycle.vue?vue&type=script&lang=js"
export * from "./MenuCycle.vue?vue&type=script&lang=js"

import "./MenuCycle.vue?vue&type=style&index=0&id=9a90866a&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__